(function (angular) {
	'use strict';

	angular
		.module('serviceLevelModule')
		.controller('PlusPlanOptIn', [
			'ServiceLevelFactory',
			'urlFactory',
			PlusPlanOptInFunction
		]);

	function PlusPlanOptInFunction(
		ServiceLevelFactory,
		urlFactory
	) {
		var plusPlanOptIn = this;
		var nextServiceLevelName = 'ADVANCED';

		function continueToNewAllocation(riaPlanId) {
			plusPlanOptIn.investAndUpgradeForm = {
				riaPlanId: riaPlanId,
				serviceLevelUpgrade: nextServiceLevelName
			};

			urlFactory.submitFormById('invest-and-upgrade-form');
		}

		function submitUpgrade(riaPlanId) {
			ServiceLevelFactory.upgradeServiceLevelAndRiaPlan(nextServiceLevelName, riaPlanId)
				.then(function() {
					urlFactory.redirect('/account/upgrade/' + nextServiceLevelName.toLowerCase()  + '/success');
				});
		}

		plusPlanOptIn.handleContinue = function(riaPlanId) {
			if(plusPlanOptIn.isInvestAndUpgrade) {
				continueToNewAllocation(riaPlanId);
			} else {
				submitUpgrade(riaPlanId);
			}
		};

		plusPlanOptIn.$onInit = function() {
			angular.extend(plusPlanOptIn, globalConfig);
		};
	}
})(window.angular);